import { TokenPair } from '@kinet-open-network/shared/data-access/model';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AuthenticatedUser } from '../models/authenticated-user.model';
import { ExpirationReason } from '../models/expiration-reason.interface';
import { ILogin } from '../models/login.interface';
import { LogoutReason } from '../models/logout-reason.interface';
import { IResetPassword } from '../models/reset-password.interface';
import { ITwoFactorLogin } from '../models/two-factor-login.interface';
import { IUpdateProfile } from '../models/update-profile.interface';

export const AuthDeviceActions = createActionGroup({
  source: 'Auth/Device',
  events: {
    Init: emptyProps(),
    Initialized: props<{
      user: AuthenticatedUser | null;
    }>(),
    Logout: props<{ reason: LogoutReason }>(),
    Expired: props<{ reason: ExpirationReason; errorCode?: string }>(),
    Refresh: props<{ refreshToken: string }>(),
    Refreshed: props<{
      tokens: TokenPair;
      user: AuthenticatedUser;
    }>(),
  },
});

export const PasswordResetActions = createActionGroup({
  source: 'Auth/Password-reset',
  events: {
    Reset: props<{ data: IResetPassword }>(),
  },
});

export const AuthApiActions = createActionGroup({
  source: 'Auth/Api',
  events: {
    'Login Success': props<{
      tokens: TokenPair;
      user: AuthenticatedUser;
    }>(),
    'Login Failure': props<{ error: unknown }>(),
    'Logout Success': props<{ reason: LogoutReason }>(),
    'Logout Failure': props<{ error: unknown }>(),
    'Reset success': emptyProps(),
    'Reset failure': props<{ error: unknown }>(),
    'ForgotPwd success': props<{ email: string }>(),
    'ForgotPwd failure': props<{ error: unknown }>(),
    'Two Factor Awaiting': props<{ data: ILogin }>(),
    'Two Factor Required': props<{ data: ILogin }>(),
    'Update Profile Success': props<{ user: AuthenticatedUser }>(),
    'Update Profile Failure': props<{ error: unknown }>(),
  },
});

export const AuthLoginActions = createActionGroup({
  source: 'Auth/Login Page',
  events: {
    Login: props<{ data: ILogin }>(),
    ForgotPwd: props<{ email: string }>(),
  },
});

export const AuthTwoFactorLoginActions = createActionGroup({
  source: 'Auth/Two-Factor Login',
  events: {
    Login: props<{ data: ITwoFactorLogin }>(),
  },
});

export const AuthShellActions = createActionGroup({
  source: 'Auth/Shell',
  events: {
    Logout: props<{ reason: LogoutReason }>(),
  },
});

export const AuthProfileActions = createActionGroup({
  source: 'Auth/Profile',
  events: {
    Update: props<{ data: IUpdateProfile }>(),
  },
});

export const AuthChangePasswordActions = createActionGroup({
  source: 'Auth/Change Password',
  events: {
    Change: props<{ data: IResetPassword }>(),
  },
});
